module.exports = __webpack_public_path__ + "static/media/hand3.520efbb5.bin";